module.exports = __webpack_public_path__ + "img/coin2.a38dd3ba.png";